/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Models */
import { DsMapLayer } from '../models/ds-map-layer.class';
import { BydModel } from '@sixense/byd-core-service';

@Injectable({
  providedIn: 'root',
})
export class DsMapLayersService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get layers.
   *
   * @param projectId The project id.
   * @returns Observable of <BydModel<DsMapLayer>>
   */
  public getLayers(projectId: number): Observable<BydModel<DsMapLayer>> {
    this.path = `/projects/${projectId}/layers`;
    return this.getModels<DsMapLayer>();
  }

  /**
   * Add a new layer.
   *
   * @param projectId the project id
   * @param title new layer's title
   * @returns Observable<DsMapLayer>
   */
  public addLayer(projectId: number, title: string): Observable<DsMapLayer> {
    this.path = `/projects/${projectId}/layers`;
    return this.putModel<DsMapLayer>({ body: { title } });
  }

  /**
   * Archive a layer.
   *
   * @param projectId the project id
   * @param layerId the layer id
   * @returns Observable<DsMapLayer>
   */
  public deleteLayer(projectId: number, layerId: number): Observable<DsMapLayer> {
    this.path = `/projects/${projectId}/layers/${layerId}`;
    return this.delete<DsMapLayer>();
  }

  /**
   * Get user groups linked to the selected layer.
   *
   * @param projectId the project id
   * @param layerId the layer id
   * @returns Observable<number[]>
   */
  public getLayerUserGroups(projectId: number, layerId: number): Observable<number[]> {
    this.path = `/projects/${projectId}/layers/${layerId}/usergroups`;
    // TODO:  Set up the correct type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.get<any>().pipe(
      // TODO:  Set up the correct type
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      map((ids: any[]) => {
        const usergroupIds: number[] = [];
        ids.forEach((id) => usergroupIds.push(id.groupId));
        return usergroupIds;
      })
    );
  }

  /**
   * Add a user group to the selected layer.
   *
   * @param projectId the project id
   * @param layerId layer id, corresponds to notes_id
   * @param groupId user group id
   * @returns Observable
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public addLayerUserGroup(projectId: number, layerId: number, groupId: number): Observable<any> {
    this.path = `/projects/${projectId}/layers/${layerId}/usergroups/${groupId}`;
    return this.put(null);
  }

  /**
   * Remove a user group from the selected layer.
   *
   * @param projectId the project id
   * @param layerId layer id, corresponds to notes_id
   * @param groupId user group id
   * @returns Observable
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public deleteLayerUserGroup(projectId: number, layerId: number, groupId: number): Observable<any> {
    this.path = `/projects/${projectId}/layers/${layerId}/usergroups/${groupId}`;
    return this.delete();
  }

  /**
   * Create DsMapLayer instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsMapLayer` instance.
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public createNewInstance(jsonObject: any): DsMapLayer {
    return new DsMapLayer(jsonObject.id, jsonObject.title);
  }
}
